import React, { useEffect, useState } from "react";

const FakeRunningBattle = ({ translations, language, winnAmount }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  // console.log("addCaseSetting", addCaseSetting);
  // const [fakeBattles, setFakeBattles] = useState([]);
  const [fakeRunningBattles, setFakeRunningBattles] = useState([]);
  const indianNames = [
    "Aman",
    "Rahul",
    "Rohit",
    "Vikas",
    "Ankit",
    "Neha",
    "Riya",
    "Pooja",
    "Karan",
    "Yash",
  ];

  const attitudeNames = [
    "King",
    "Jaat",
    "Mahakal",
    "Don",
    "Badshah",
    "Legend",
    "Boss",
    "Royal",
  ];

  const emojis = [
    "🔥🔥",
    "😎😎😎😎",
    "👑",
    "🌹🌹🌹",
    "❤️",
    "💀💀",
    "👑⚡👑",
    "🚩",
    "🔥🦁🔥",
    "👑💎",
  ];

  const generateRandomString = () => {
    const chars = "abcdefghijklmnopqrstuvwxyz";

    const len = Math.floor(Math.random() * 4) + 5;

    let str = "";

    for (let i = 0; i < len; i++) {
      str += chars[Math.floor(Math.random() * chars.length)];
    }

    return str;
  };
  const getRandomName = () => {
    const rand = Math.random();

    // 60% random names
    if (rand < 0.6) {
      return generateRandomString();
    }

    // 20% indian names
    if (rand < 0.8) {
      return indianNames[Math.floor(Math.random() * indianNames.length)];
    }

    // 15% attitude names
    if (rand < 0.95) {
      return attitudeNames[Math.floor(Math.random() * attitudeNames.length)];
    }

    // 5% attitude + emoji
    return `${attitudeNames[Math.floor(Math.random() * attitudeNames.length)]}${
      emojis[Math.floor(Math.random() * emojis.length)]
    }`;
  };

  const generateUniqueNames = (count) => {
    const names = [];
    const used = new Set();

    while (names.length < count) {
      const name = getRandomName();

      if (!used.has(name)) {
        used.add(name);
        names.push(name);
      }
    }

    return names;
  };

  const shuffleArray = (array) => {
    const arr = [...array];

    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));

      [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    return arr;
  };

  const getRandomAmount = () => {
    const rand = Math.random();

    // 35%
    if (rand < 0.35) {
      const values = [
        50, 100, 150, 200, 250, 300, 350, 400, 500, 600, 700, 800, 900, 1000,
        1200, 1500,
      ];

      return values[Math.floor(Math.random() * values.length)];
    }

    // 35%
    if (rand < 0.7) {
      const values = [
        1600, 1650, 1700, 1800, 1850, 1900, 2000, 2050, 2100, 2200, 2600, 2400,
        2500, 2550, 2600, 2700, 2800, 2900, 3000,
      ];

      return values[Math.floor(Math.random() * values.length)];
    }

    // 25%
    if (rand < 0.95) {
      const values = [
        3100, 3200, 3300, 3400, 3500, 3600, 3700, 3800, 3900, 3950, 4000, 4100,
        4200, 4250, 4300, 4350, 4400, 4450, 4500, 4600, 4650, 4700, 4800, 4850,
        4900, 5000, 5100, 5200, 5300, 5400, 5500, 5560, 5650, 5700, 5800, 5900,
        6000, 6200, 6300, 6400, 6500, 7000,
      ];

      return values[Math.floor(Math.random() * values.length)];
    }

    // 4%
    if (rand < 0.99) {
      const values = [
        11000, 11500, 12000, 12300, 12500, 12800, 13000, 13500, 13500, 13900,
        14000, 14500, 15000,
      ];

      return values[Math.floor(Math.random() * values.length)];
    }

    // 1%
    const values = [
      20000, 21000, 22000, 23000, 24000, 25000, 26000, 28000, 30000,
    ];

    return values[Math.floor(Math.random() * values.length)];
  };
  const createFakeBattle = () => {
    let player1 = getRandomName();
    let player2 = getRandomName();

    while (player1 === player2) {
      player2 = getRandomName();
    }

    return {
      _id: `fake_${Date.now()}_${Math.random()}`,

      Status: "running",

      Game_Ammount: getRandomAmount(),

      Created_by: {
        _id: "bot1",
        Name: player1,
      },

      Accepetd_By: {
        _id: "bot2",
        Name: player2,
      },
    };
  };

  //   const ADMIN_FAKE_RUNNING_COUNT = 50; // backend se aayega
  const ADMIN_FAKE_RUNNING_COUNT = addCaseSetting?.runningBotNumber || 50;

  const getRandomBattleCount = (count) => {
    const min = Math.max(count - 15, 1);

    const max = count + 15;

    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  useEffect(() => {
    const battleCount = getRandomBattleCount(ADMIN_FAKE_RUNNING_COUNT);

    const names = generateUniqueNames(battleCount * 2);

    const battles = [];

    for (let i = 0; i < battleCount; i++) {
      battles.push({
        _id: `fake_${i}`,

        Status: "running",

        Game_Ammount: getRandomAmount(),

        Created_by: {
          _id: `bot_c_${i}`,
          Name: names[i * 2],
        },

        Accepetd_By: {
          _id: `bot_a_${i}`,
          Name: names[i * 2 + 1],
        },
      });
    }

    setFakeRunningBattles(battles);
  }, []);
  useEffect(() => {
    const replaceRandomBattle = () => {
      setFakeRunningBattles((prev) => {
        if (!prev.length) return prev;

        const updated = [...prev];

        const randomIndex = Math.floor(Math.random() * updated.length);

        updated[randomIndex] = createFakeBattle();

        return updated;
      });
    };

    const interval = setInterval(() => {
      replaceRandomBattle();
    }, 90000);
    // 90 seconds

    return () => clearInterval(interval);
  }, []);

  const truncateName = (name) => {
    return name?.length > 5 ? `${name.slice(0, 5)}...` : name;
  };

  return (
    <>
      {fakeRunningBattles.map((runnig) => (
        <div className="prince_running_match_card" key={runnig._id}>
          {/* Header */}
          <div className="prince_running_match_header">
            <span className="prince_running_status">
              <span className="prince_running_status_dot"></span>
              LIVE MATCH
            </span>

            <div className="prince_running_players">
              <span>{truncateName(runnig.Created_by.Name)}</span>

              <b>&</b>

              <span>{truncateName(runnig.Accepetd_By.Name)}</span>
            </div>
          </div>

          {/* Match Body */}
          <div className="prince_running_match_body">
            {/* Entry Fee */}
            <div className="prince_running_side_box">
              <span className="prince_running_side_title">
                {translations[language].entry}
              </span>

              <div className="prince_running_money">
                <img src="/images/moneyrupee.png" alt="" />

                <strong>{runnig.Game_Ammount}</strong>
              </div>
            </div>

            {/* VS */}
            <div className="prince_running_match_center">
              <div className="prince_running_vs_box">
                <span className="prince_running_vs_line"></span>

                <img
                  src="../images/VS-image.png"
                  className="prince_running_match_vs"
                  alt=""
                />

                <span className="prince_running_vs_line"></span>
              </div>
            </div>

            {/* Winning Prize */}
            <div className="prince_running_side_box prince_running_prize_box">
              <span className="prince_running_side_title">
                {translations[language].prize}
              </span>

              <div className="prince_running_money">
                <img src="/images/moneyrupee.png" alt="" />

                <strong>
                  {runnig.Game_Ammount + winnAmount(runnig.Game_Ammount)}
                </strong>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default FakeRunningBattle;
